import React, { Component } from "react";
import NavbarComponent from "../components/NavbarComponent";

import StatusMessageComponent from "../components/StatusMessageComponent";

class mainView extends Component {
  state = {};
  render() {
    return (
      <React.Fragment>
        <NavbarComponent/>
        <StatusMessageComponent />
      </React.Fragment>
    );
  }
}

export default mainView;
